import React, { useState } from 'react'
import { InvestmentTitleText } from 'src/components/Global/Text/TitleText'
import { ModalButton } from 'src/components/Global/Button/Button'
import { CreatePinDto } from 'src/services/types'
import { useDispatchProxy } from 'src/redux'
import { Spinner } from 'src/components/Global/Spinner/Spinner'
import { Wrapper, FormContainer } from './style'
import PinInput from 'react-pin-input'
import { createPinAction } from 'src/redux/actions/profileAction'
import useSnackbar from 'src/hooks/useSnackBar'
import { useNavigate } from 'react-router-dom'
import { ModalTitleText, LabelText } from 'src/components/Global/Text/TitleText'

const CreatePin = () => {
  const [userData, setUserData] = useState<CreatePinDto>({
    pin: '',
    pin_confirmation: '',
  })

  const dispatch = useDispatchProxy()
  const { pin, pin_confirmation } = userData
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState<boolean>(false)
  const navigate = useNavigate()
  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...userData }
    newData[name] = value
    setUserData(newData)
  }

  const CreatePin = (e: any) => {
    e.preventDefault()
    if (
      !pin ||
      !pin_confirmation ||
      pin.length !== 6 ||
      pin !== pin_confirmation
    ) {
      setSubmitted(true)
      return
    }
    setLoading(true)
    dispatch(createPinAction({ userData, onSuccess, onError }))
  }
  const snackbar = useSnackbar()

  const onSuccess = (msg: any) => {
    setLoading(false)
    snackbar.trigger({
      message: msg,
      severity: 'success',
    })
    setTimeout(() => {
      navigate(-1)
    }, 1500)
  }

  const onError = (error: any) => {
    setLoading(false)
    snackbar.trigger({
      message: 'Pin already created, kindly update your pin"',
      severity: 'error',
    })
  }
  return (
    <FormContainer>
      <Wrapper>
        <div>
          <ModalTitleText>Create Pin</ModalTitleText>
          <div className="amount">
            <LabelText>New pin</LabelText>
            <div
              className={'form-group' + (submitted && !pin ? ' has-error' : '')}
            >
              <PinInput
                length={6}
                initialValue=""
                secret
                type="numeric"
                onChange={(value, index) => {
                  userData['pin'] = value
                  setUserData(userData)
                }}
                inputMode="number"
                style={{
                  padding: '16px',
                  marginTop: '-20px',
                }}
                inputStyle={{
                  borderColor: '#6E7191',
                }}
                inputFocusStyle={{ borderColor: '#0519ff' }}
                autoSelect={true}
                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
              />
              {(submitted && !pin && (
                <p className="error-text">Enter your new pin</p>
              )) ||
                (submitted && pin.length !== 6 && (
                  <p className="error-text">Pin must be 6 digits</p>
                ))}
            </div>
          </div>
          <div className="amount">
            <LabelText>Confirm pin</LabelText>
            <div
              className={
                'form-group' +
                (submitted && pin !== pin_confirmation ? ' has-error' : '')
              }
            >
              <PinInput
                length={6}
                initialValue=""
                secret
                type="numeric"
                inputMode="number"
                onChange={(value, index) => {
                  userData['pin_confirmation'] = value
                  setUserData(userData)
                }}
                style={{ padding: '16px', marginTop: '-20px' }}
                inputStyle={{ borderColor: '#6E7191' }}
                inputFocusStyle={{ borderColor: '#2336FF' }}
                autoSelect={true}
                regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
              />
              {submitted && pin !== pin_confirmation && (
                <p className="error-text">Both Pins DO not match!</p>
              )}
            </div>
          </div>
        </div>
        <ModalButton onClick={CreatePin}>
          Create Pin {loading && <Spinner />}
        </ModalButton>
      </Wrapper>
    </FormContainer>
  )
}
export { CreatePin }
